interface RatingDisplayProps {
  rating: number | null;
}

export function RatingDisplay({ rating }: RatingDisplayProps) {
  if (!rating) return null;

  const safeRating = Math.max(1, Math.min(5, Math.round(rating)));

  return (
    <div className="flex items-center gap-2" aria-label={`${safeRating} out of 5 rating`}>
      <div className="flex gap-1">
        {Array.from({ length: 5 }, (_, index) => (
          <span
            key={index}
            className={index < safeRating ? "text-cyan-200 drop-shadow-[0_0_8px_rgba(34,211,238,0.75)]" : "text-white/20"}
          >
            *
          </span>
        ))}
      </div>
      <span className="text-xs font-semibold uppercase tracking-[0.16em] text-content-muted">
        {safeRating}/5
      </span>
    </div>
  );
}
